import { useQuery } from '@tanstack/react-query';

import { GetCompanyRegistrationStatus } from '../../../http/Company/CompanyRegistration';
import { CompanyRegistrationMessage } from '../../../http/Company/Models/companyRegistrationMessage';
import queryKeys from './queryKeys';

const useCompanyRegistrationInfo = () => {
  const query = useQuery<CompanyRegistrationMessage>({
    queryKey: [queryKeys.companyRegistrationInfo],
    queryFn: GetCompanyRegistrationStatus,
    staleTime: Infinity
  });

  return query;
};

export default useCompanyRegistrationInfo;
